// extracted by mini-css-extract-plugin
module.exports = {"session":"UserSessions_session__1vSYX","icon":"UserSessions_icon__1SJ4-","details":"UserSessions_details__3YbZj","revokeForm":"UserSessions_revokeForm__3x_M1"};